import React from 'react';
import WorkOrderTable from '../WorkOrderTable';
import { BUYER_WO_FILTERS_ORDER } from '../../utils/WorkOrderUtils';
import posthog from 'posthog-js';
import WorkOrderFiltersWrapper from '../work_order_filters_wrapper/WorkOrderFiltersWrapper';

export default function WorkOrdersArchivedIndexPage() {
	return (
		<WorkOrderFiltersWrapper>
			{(defaultFilters) => (
				<WorkOrderTable
					handleQueryParams
					preAppliedFilters={{ hasBuyerArchived: true }}
					filterConfig={{
						filters: BUYER_WO_FILTERS_ORDER,
					}}
					targetCollectionName="archivedWorkOrdersIndex"
					initialFilters={defaultFilters}
				/>
			)}
		</WorkOrderFiltersWrapper>
	);
}
